import { render } from "./CommonSettingsList.vue?vue&type=template&id=3ef1d118&scoped=true"
import script from "./CommonSettingsList.vue?vue&type=script&lang=js"
export * from "./CommonSettingsList.vue?vue&type=script&lang=js"

import "./CommonSettingsList.vue?vue&type=style&index=0&id=3ef1d118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef1d118"]])

export default __exports__